export default __webpack_public_path__ + "static/media/ImgTicket02.9e00ecff.jpg";